import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"text-center w-full error-page pa-3"},[_c(VImg,{attrs:{"src":require('@/assets/images/404-illustration.svg'),"max-height":"300","contain":""}}),_c('div',{staticClass:"display-2 mt-10"},[_vm._v("How did you get here?")]),_c('div',{staticClass:"mt-3 mb-6"},[_vm._v("Sorry we can't seem to find the page you're looking for.")]),_c(VBtn,{attrs:{"to":"/","block":"","large":"","color":"primary"}},[_vm._v("Send me Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }